/*
 * NextGenn engine · goes with, when the product does not say (sections/ngs-pairs.liquid).
 *
 * Only loaded for a product with no `loz.pairs_with`. It asks Shopify's
 * recommendations for this same section, rendered with products in it, and
 * moves the cards across; the <ngs-add> buttons in them wake up on their own.
 * It waits until the section is near the screen, because a product page nobody
 * scrolls should not cost Shopify a recommendation. Nothing to show, or no
 * answer: the section stays hidden, which is how it started.
 */
(function () {
  if (customElements.get('ngs-pairs')) return;

  customElements.define(
    'ngs-pairs',
    class NGSPairs extends HTMLElement {
      connectedCallback() {
        if (this.asked || !this.dataset.url) return;
        this.list = this.querySelector('[data-ngs-pairs-list]');
        if (!this.list || this.list.children.length) return;

        if (!('IntersectionObserver' in window)) {
          this.ask();
          return;
        }
        /* Hidden things never intersect, so the watcher sits on the section's own wrapper. */
        var mark = this.parentElement || this;
        this.watcher = new IntersectionObserver(
          function (entries) {
            if (
              !entries.some(function (entry) {
                return entry.isIntersecting;
              })
            )
              return;
            this.watcher.disconnect();
            this.ask();
          }.bind(this),
          { rootMargin: '0px 0px 600px 0px' }
        );
        this.watcher.observe(mark);
      }

      disconnectedCallback() {
        if (this.watcher) this.watcher.disconnect();
      }

      ask() {
        if (this.asked) return;
        this.asked = true;
        fetch(this.dataset.url)
          .then(function (response) {
            return response.ok ? response.text() : '';
          })
          .then(
            function (text) {
              if (!text) return;
              var page = new DOMParser().parseFromString(text, 'text/html');
              var cards = page.querySelector('[data-ngs-pairs-list]');
              if (!cards || !cards.children.length) return;
              this.list.innerHTML = cards.innerHTML;
              this.hidden = false;
            }.bind(this)
          )
          .catch(function () {
            /* No recommendations is not an error the customer needs to hear about. */
          });
      }
    }
  );
})();
